/**
 * Created by Allan on 2022/08/03.
 * Contact 84880528@qq.com.
 * 催收还款H5项目
 */
import Vue from 'vue'
import App from './App'
import Vant from 'vant'
import store from './store/'
import router from './router'
import Http from './services/http/'
import { Base64 } from 'js-base64'
import getQueryVariable from '@/repayment/services/getQueryVariable'
import './filter/'
import 'vant/lib/index.css'
import axios from 'axios'

Vue.use(Vant)
Vue.prototype.$http = Http;
Vue.config.productionTip = false

// 路由拦截
router.beforeEach((to, from, next) => {
    //let user=store.state.user.user;
    let user=JSON.parse(localStorage.getItem('user')) || {};
    let appParams=JSON.parse(localStorage.getItem('appParams')) || {};
    let gstAppParams=JSON.parse(localStorage.getItem('gstAppParams')) || {};
    let appId=Base64.decode(getQueryVariable('a'))

    //路由发生变化修改页面Title
    if(to.meta.title==='loginPhone' || to.meta.title==='loginCode'){
        document.title=Base64.decode(getQueryVariable('n')?getQueryVariable('n'):'');
        return next()
    }else{
        if(JSON.stringify(user)!=='{}'){
            if(appId===user.appId){
                document.title=Base64.decode(getQueryVariable('n')?getQueryVariable('n'):'');
                next();
            }else{
                localStorage.clear();
                next(`/login?a=${getQueryVariable('a')}&n=${getQueryVariable('n')}&c=${getQueryVariable('c')}`);
            }
        }else{
            next();
        }
    }
});

router.afterEach((to,from,next) => {
    if(to.name==='order' || to.name==='orderDetails' || to.name==='orderSpe' || to.name==='orderOxxo' || to.name==='orderResult' || to.name==='debtbehavior'){
        window.scrollTo(0,0);
    }
});

new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/repayment/main.js